import React from 'react';
import { ArcIconButton, ArcStack, ArcTooltip } from '@src/core/ui';
import { ToolbarAction } from './types';

interface CameraToolbarProps {
  actions: ToolbarAction[];
}

const CameraToolbar: React.FC<CameraToolbarProps> = ({ actions }) => {
  return (
    <ArcStack
      top={5}
      right={5}
      spacing={0.5}
      zIndex={100}
      direction='row'
      position='absolute'
      alignItems='center'>
      {actions.map(({ key, icon, onClick, disabled }) => (
        <ArcTooltip key={key} title={key}>
          <ArcIconButton
            disabled={disabled}
            onClick={onClick}
            sx={{ p: 0.5, width: 30, height: 30, color: 'common.white', '& .MuiSvgIcon-root': { fontSize: 20 } }}>
            {icon}
          </ArcIconButton>
        </ArcTooltip>
      ))}
    </ArcStack>
  );
};

export default CameraToolbar;
